import { render, staticRenderFns } from "./ed-dropzone.vue?vue&type=template&id=21259f3e&scoped=true&"
import script from "./ed-dropzone.ts?vue&type=script&lang=js&"
export * from "./ed-dropzone.ts?vue&type=script&lang=js&"
import style0 from "./ed-dropzone.scss?vue&type=style&index=0&id=21259f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21259f3e",
  null
  
)

export default component.exports